const sol_242 = `
\`\`\`python
class Solution:
    def isAnagram(self, s: str, t: str) -> bool:
        return Counter(s) == Counter(t)
\`\`\`
`;

export default sol_242;
